import { updateList } from '@/mocks/homeData';

const typeStyle: Record<string, string> = {
  新增: 'bg-accent-100 text-accent-900',
  校对: 'bg-secondary-100 text-secondary-900',
  调整: 'bg-primary-100 text-primary-800',
};

export default function UpdateLog() {
  return (
    <section id="updates" className="w-full scroll-mt-28 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="font-label text-xs font-medium uppercase tracking-widest text-primary-600">
            Updates
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            更新日志：字幕整理的最新进度
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            记录近期各章节的译制、校对与调整情况。想追更的观众可以按日期对照，
            优先查看最近完成校对的条目。
          </p>
        </div>

        <ol className="mt-8 space-y-0 border-l border-background-300/70 pl-6">
          {updateList.map((item) => (
            <li key={`${item.date}-${item.title}`} className="relative pb-8 last:pb-0">
              <span className="absolute -left-[31px] top-1.5 flex h-3.5 w-3.5 items-center justify-center rounded-full border-2 border-background-100 bg-primary-500"></span>
              <div className="flex flex-wrap items-center gap-2">
                <time className="font-label text-xs text-foreground-500">{item.date}</time>
                <span className={`rounded-full px-2.5 py-0.5 font-label text-xs font-medium ${typeStyle[item.type]}`}>
                  {item.type}
                </span>
              </div>
              <h3 className="mt-2 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-1 text-sm leading-relaxed text-foreground-600">{item.detail}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}